// Declare your assets here — they preload before "ready" fires, then live
// in experience.resources.items keyed by name. Put the files in static/.
//
// Types: gltfModel | glbModel | texture | cubeTexture | font | exr
//        | simulationData (fetches raw text — CSV, JSON, whatever)
export default [
  // { name: "goggleModel", type: "glbModel", path: "./goggle.glb" }, // avatars wear these if present
  //{ name: "starTexture", type: "texture", path: "./textures/star.png" },
  { name: "daytimeSkyTexture", type: "exr", path: "./skies/qwantani_moon_noon_puresky_4k.exr" }
];